import { Helmet } from "react-helmet-async";
import { SITE_URL as BASE } from "@/lib/site";
const OG_IMG_MAP = {
  default: "https://images.unsplash.com/photo-1704093240724-891c11815f42?crop=entropy&cs=srgb&fm=jpg&w=1200&h=630&fit=crop&q=85",
  ai: "https://images.unsplash.com/photo-1653119574903-ae9c3204bc35?crop=entropy&cs=srgb&fm=jpg&w=1200&h=630&fit=crop&q=85",
  justice: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?crop=entropy&cs=srgb&fm=jpg&w=1200&h=630&fit=crop&q=85",
  institute: "https://images.unsplash.com/photo-1727221167365-d365e63e7ebc?crop=entropy&cs=srgb&fm=jpg&w=1200&h=630&fit=crop&q=85",
};

export default function SEO({ title, description, path = "/", image = "default", type = "website" }) {
  const url = `${BASE}${path}`;
  // Support absolute URLs, local paths starting with /, or map keys
  let img;
  if (image.startsWith("http")) img = image;
  else if (image.startsWith("/")) img = `${BASE}${image}`;
  else img = OG_IMG_MAP[image] || OG_IMG_MAP.default;
  const fullTitle = `${title} · IOCRI`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
